<template>
  <div class="studio-lessons-preview" v-bind="$attrs">
    <h1 class="mb-4">
      {{ data.title }}
    </h1>
    <NuxtLink
      v-for="(lesson, index) in limitedLessons"
      :key="lesson.id"
      class="undecorated-router-link mt-2"
      :to="{
        name: 'studio-product-lessons',
        query: { selected_lesson: index },
      }"
    >
      <StudioLessonCard
        class="mb-2"
        :lesson="lesson"
        :index="index + 1"
        :total="lessons.length"
        :isSelected="false"
        :hasAccess="canViewProductContent"
      >
    </StudioLessonCard>
    </NuxtLink>
    <div v-if="remainingLessonsLength > 0" class="mt-2">
      <NuxtLink
        class="undecorated-router-link mt-2"
        :to="{ name: 'studio-product-lessons' }"
      >
        <i class="fa fa-calendar-o c-brand-color me-2"></i>
        {{
          $t('PRODUCTS.LABELS.MORE_LESSONS_VARIANT', {
            remainingLessonsLength,
          }, remainingLessonsLength)
        }}
      </NuxtLink>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useProductStore } from '@/stores';
import StudioLessonCard from '@/components/products/StudioLessonCard.vue';

export default {
  name: 'StudioLessonsPreview',
  components: {
    StudioLessonCard,
  },
  props: {
    limit: {
      type: Number,
      default: 3,
    },
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState(useProductStore, {
      product: 'product',
      productLessons: 'productLessons',
      canViewProductContent: 'canViewProductContent',
    }),
    lessons() {
      return this.productLessons;
    },
    limitedLessons() {
      return this.lessons.slice(0, this.limit);
    },
    remainingLessonsLength() {
      return Math.max(0, this.lessons.length - this.limit);
    },
  },
};
</script>

<style lang="scss" scoped></style>
